import { Component, ViewChild, AfterViewInit, Input, OnChanges } from '@angular/core';
import * as echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/toolbox';
import { StatsService } from '../../stats.service';
import { createPieChart } from './pieChart';
import { getChartTheme } from '../themes/customTheme';
import { getChartSize } from '../chartUtils';
import { tap, first } from 'rxjs/operators';
import * as store from 'store';
import { ThemeDirective } from '../../../../theme/theme.directive';
@Component({
  selector: 'app-pie-chart',
  template: `
    <div class="full-width">
    	<div        #chart style="height:30vh;width:100%;" [ngClass]="{ hide: !containsData, 'full-width': true }"></div>
    	<div style="height:30vh;width:90%;" [ngClass]="{ hide: containsData, 'full-width': true, 'chart-no-data': true }">
    		<i class="fa fa-pie-chart" aria-hidden="true"></i>
    		<div>{{ 'stats.no_data' | translate }}</div>
    	</div>
    </div>`,
  styleUrls: ['./pie.components.css']
})
export class PieChartComponent implements AfterViewInit, OnChanges {
  @Input() url: Function;
  @Input() options: any;
  @Input() sessionId: any;
  pieSlider = 10;
  chartInstance: any;
  containsData = false;
  @ViewChild('chart') chart;

  constructor(private statsService: StatsService) {}

  ngOnChanges() {
    this.updatePieChart();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      const parent = this.chart.nativeElement as HTMLDivElement;
      const parentSize = getChartSize(parent);
      const theme = store.get(ThemeDirective.THEME);
      const chartTheme = getChartTheme(theme);
      this.chartInstance = echarts.init(parent, chartTheme, parentSize);
      this.updatePieChart();
    }, 0);
  }
  updatePieChart() {
    if (this.chartInstance !== undefined) this.chartInstance.showLoading();

    const source$ = this.statsService.call(`${this.url(this.sessionId)}/${this.pieSlider}`);
    const setContainsData$ = tap((data: any) => (this.containsData = data.length > 0));
    const setOptions$ = tap(data =>
      this.chartInstance.setOption(createPieChart(data, this.options(data, this.pieSlider)))
    );
    const hideLoading$ = tap(() => this.chartInstance.hideLoading());

    source$.pipe(first(), setContainsData$, setOptions$, hideLoading$).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/charts/pie/pie.component.ts